import React, { Component } from 'react';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import InputAdornment from '@material-ui/core/InputAdornment';
import { shortDate, getDateFromHours } from 'helpers/_date-helpers';
import styles from './styles';
import { isIOS, Option } from '../../../Option';
import { generateIncrement } from 'helpers/generateIncrement';
import { generateHoursObject, generateTravelTimeHours, isSelectedTimeValid } from 'helpers/helpers';
import _ from 'lodash';
import { connect } from 'react-redux';
import { getTimeFormat, DAY_PART } from 'common/dateFormatConfig';
import { generateIncrementDateCreator } from 'hooks/useTimeStates';
class HoursBlock extends Component {
  state = {
    days: ['-1', '0', '1'],
    hours: generateIncrement(
      generateIncrementDateCreator({ maxValue: 12, step: 1, start: 1 }, this.props.timeFormat)
    ),
    minutes: generateIncrement({ maxValue: 60, step: 5, padMaxLength: 2 }),
    amPm: DAY_PART,
    values: {
      dayStart: '0',
      hourStart: '1',
      minuteStart: '00',
      amPmStart: DAY_PART[0],
      dayEnd: '0',
      hourEnd: '1',
      minuteEnd: '00',
      amPmEnd: DAY_PART[0],
      travelTimeToHours: '0',
      travelTimeToMinutes: '0',
      travelTimeFromHours: '0',
      travelTimeFromMinutes: '0',
      isShowTT: false,
      isShowHours: false,
    },
    isValid: true,
    errors: [],
    originValues: null,
  };

  componentDidMount() {
    const { sheet, itemHours } = this.props;
    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    const hourObj = sheet.travelTimeOnly
      ? {}
      : generateHoursObject(itemHours?.start, itemHours?.end, sheet.createdAt, getTimeFormatHook);
    const travelTimesObj = generateTravelTimeHours(
      itemHours?.travelTimeTo,
      itemHours?.travelTimeFrom,
      '0'
    );

    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        ...hourObj,
        ...travelTimesObj,
        isShowTT: !itemHours.isWlTravelTime,
        isShowHours: !itemHours.isWlHours,
      },
      originValues: { ...prevState.values, ...hourObj },
    }));
  }

  componentDidUpdate(prevProps) {
    if (_.isEqual(this.props, prevProps)) return;

    const { itemHours } = this.props;
    const travelTimesObj = generateTravelTimeHours(
      itemHours?.travelTimeTo,
      itemHours?.travelTimeFrom
    );

    // if (
    //   this.props?.itemHours?.isWlHours !== prevProps?.itemHours?.isWlHours ||
    //   this.props?.itemHours?.isWlTravelTime !== prevProps?.itemHours?.isWlTravelTime ||
    //   !_.isEqual(this.props, prevProps)
    // ) {
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        isShowHours: !this.props?.itemHours?.isWlHours,
        isShowTT: !this.props?.itemHours?.isWlTravelTime,
        ...travelTimesObj,
      },
    }));
    // }
    // else if (this.props?.itemHours?.isWlTravelTime !== prevProps?.itemHours?.isWlTravelTime) {
    //   this.setState((prevState) => ({
    //     values: {
    //       ...prevState.values,
    //       isShowTT: !this.props?.itemHours?.isWlTravelTime,
    //       ...travelTimesObj,
    //     },
    // }));
    // }
  }

  handleChange = (field) => (e) => {
    e.persist();
    const { updateResourceHours, itemHours, sheet, isEquipment } = this.props;
    const { values } = this.state;
    const getTimeFormatHook = (hourObj) =>
      getTimeFormat(hourObj, this.props.timeFormat, this.props.dateFormat);
    this.setState(
      (prevState) => ({
        values: { ...prevState.values, [field]: e.target.value },
      }),
      () => {
        const { isValid, errorsOnFields } = isSelectedTimeValid(
          this.state.values,
          getTimeFormatHook
        );

        this.setState({ isValid, errors: errorsOnFields });
        const { start, end, travelTimeTo, travelTimeFrom } = getDateFromHours(
          this.state.values,
          sheet.createdAt,
          getTimeFormatHook
        );
        if (isEquipment) {
          const updatedHours = {
            start,
            end,
            travelTimeTo,
            travelTimeFrom,
          };
          if (!isValid) {
            updatedHours.isNotValid = true;
          } else {
            delete updatedHours.isNotValid;
          }
          updateResourceHours(updatedHours);
        } else {
          const updatedHours = { ...itemHours, start, end, travelTimeTo, travelTimeFrom };
          if (!isValid) {
            updatedHours.error = true;
          } else {
            delete updatedHours.error;
          }
          if (!values.isShowHours && values.isShowTT) {
            delete updatedHours.start;
            delete updatedHours.end;
          }
          updateResourceHours(updatedHours);
        }
      }
    );
  };

  render() {
    const {
      classes,
      sheet,
      deleteTime,
      deleteTravelTime,
      itemHours,
      isWorkersType,
      isEquipment,
      isAnyCropped,
    } = this.props;
    const { days, hours, minutes, amPm, values, errors } = this.state;
    const canEdit = this.props.canEdit === undefined ? true : this.props.canEdit;

    return (
      <div>
        {!sheet?.travelTimeOnly && values.isShowHours && (
          <div className={classes.flexBox}>
            <div style={{ width: '100%' }}>
              <div
                className={classnames(
                  classes.inlineFlex,
                  classes.rowWrapper,
                  classes.startTimeWrapper
                )}
              >
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(classes.regularFontWeight, classes.paddingBottom)}
                >
                  On Job Time:
                </Typography>
                <div className={classes.inlineFlex}>
                  <TextField
                    select
                    className={classnames(classes.textField, classes.dateField)}
                    value={values.dayStart}
                    onChange={this.handleChange('dayStart')}
                    error={errors && errors.includes('dayStart')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {days.map((value, index) => (
                      <Option key={index} value={value}>
                        {shortDate(
                          sheet.createdAt,
                          value,
                          getTimeFormat([], this.props.timeFormat, this.props.dateFormat)
                            .localDayMonth
                        )}
                      </Option>
                    ))}
                  </TextField>
                  <TextField
                    select
                    className={classes.textField}
                    value={values.hourStart}
                    onChange={this.handleChange('hourStart')}
                    error={errors && errors.includes('hourStart')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {hours.map((value, index) => (
                      <Option key={index} value={value}>
                        {value}
                      </Option>
                    ))}
                  </TextField>
                  :
                  <TextField
                    select
                    className={classes.textField}
                    value={values.minuteStart}
                    onChange={this.handleChange('minuteStart')}
                    error={errors && errors.includes('minuteStart')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {minutes.map((value, index) => (
                      <Option key={index} value={value}>
                        {value}
                      </Option>
                    ))}
                  </TextField>
                  {getTimeFormat([], this.props.timeFormat, this.props.dateFormat).is12Format && (
                    <TextField
                      select
                      className={classes.textField}
                      value={values.amPmStart}
                      onChange={this.handleChange('amPmStart')}
                      error={errors && errors.includes('amPmStart')}
                      variant="outlined"
                      fullWidth
                      disabled={!canEdit}
                      SelectProps={{
                        native: isIOS,
                      }}
                    >
                      {amPm.map((value, index) => (
                        <Option key={index} value={value}>
                          {value.toUpperCase()}
                        </Option>
                      ))}
                    </TextField>
                  )}
                </div>
              </div>
              <div className={classnames(classes.inlineFlex, classes.rowWrapper)}>
                <Typography
                  variant="body1"
                  color="textSecondary"
                  className={classnames(
                    classes.regularFontWeight,
                    classes.paddingBottom,
                    classes.mobileHidden
                  )}
                >
                  &nbsp;
                </Typography>
                <div className={classes.inlineFlex}>
                  <TextField
                    select
                    className={classnames(classes.textField, classes.dateField)}
                    value={values.dayEnd}
                    onChange={this.handleChange('dayEnd')}
                    error={errors && errors.includes('dayEnd')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {days.map((value, index) => (
                      <Option key={index} value={value}>
                        {shortDate(
                          sheet.createdAt,
                          value,
                          getTimeFormat([], this.props.timeFormat, this.props.dateFormat)
                            .localDayMonth
                        )}
                      </Option>
                    ))}
                  </TextField>
                  <TextField
                    select
                    className={classes.textField}
                    value={values.hourEnd}
                    onChange={this.handleChange('hourEnd')}
                    error={errors && errors.includes('hourEnd')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {hours.map((value, index) => (
                      <Option key={index} value={value}>
                        {value}
                      </Option>
                    ))}
                  </TextField>
                  :
                  <TextField
                    select
                    className={classes.textField}
                    value={values.minuteEnd}
                    onChange={this.handleChange('minuteEnd')}
                    error={errors && errors.includes('minuteEnd')}
                    variant="outlined"
                    fullWidth
                    disabled={!canEdit}
                    SelectProps={{
                      native: isIOS,
                    }}
                  >
                    {minutes.map((value, index) => (
                      <Option key={index} value={value}>
                        {value}
                      </Option>
                    ))}
                  </TextField>
                  {getTimeFormat([], this.props.timeFormat, this.props.dateFormat).is12Format && (
                    <TextField
                      select
                      className={classes.textField}
                      value={values.amPmEnd}
                      onChange={this.handleChange('amPmEnd')}
                      error={errors && errors.includes('amPmEnd')}
                      variant="outlined"
                      fullWidth
                      disabled={!canEdit}
                      SelectProps={{
                        native: isIOS,
                      }}
                    >
                      {amPm.map((value, index) => (
                        <Option key={index} value={value}>
                          {value.toUpperCase()}
                        </Option>
                      ))}
                    </TextField>
                  )}
                </div>
              </div>
            </div>

            <div className={classnames(classes.inlineFlex, isWorkersType && classes.reverseColumn)}>
              {canEdit && (
                <IconButton
                  className={classnames(
                    classes.deleteButton,
                    classes.individualDeleteButton,
                    isWorkersType && classes.marginBottom
                  )}
                  onClick={deleteTime}
                  aria-label="Delete"
                  disableTouchRipple
                >
                  <CloseIcon />
                </IconButton>
              )}
            </div>
          </div>
        )}
        {!isEquipment && values.isShowTT && (
          <div className={classnames(classes.rowWrapper, classes.travelTimeBlock)}>
            <>
              <div className={classnames(classes.travelInputsWrapper)}>
                <div
                  className={classnames(
                    classes.rowWrapper,
                    classes.travelTimeWrapper,
                    classes.startTimeWrapper
                  )}
                >
                  <div>
                    <Typography variant="body1" color="textSecondary">
                      Individual Time To:
                    </Typography>
                  </div>

                  <div className={classnames(classes.travelTimeInputWrapper)}>
                    <div>
                      <TextField
                        id="travelTimeToHours"
                        name="travelTimeToHours"
                        className={classnames(classes.textField, classes.travelInput)}
                        value={values.travelTimeToHours}
                        error={errors && errors.includes('travelTimeToHours')}
                        onChange={this.handleChange('travelTimeToHours')}
                        variant="outlined"
                        inputProps={{
                          'aria-label': 'Travel time hours',
                          maxLength: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <label htmlFor="travelTimeToHours" className={classes.adornment}>
                                h
                              </label>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </div>
                    <div>
                      <TextField
                        id="travelTimeToMinutes"
                        name="travelTimeToMinutes"
                        className={classnames(classes.textField, classes.travelInput)}
                        value={values.travelTimeToMinutes}
                        error={errors && errors.includes('travelTimeToMinutes')}
                        onChange={this.handleChange('travelTimeToMinutes')}
                        variant="outlined"
                        inputProps={{
                          'aria-label': 'Travel time minutes',
                          maxLength: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <label htmlFor="travelTimeToMinutes" className={classes.adornment}>
                                min
                              </label>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </div>
                  </div>
                </div>
                <div className={classnames(classes.travelTimeWrapper, classes.startTimeWrapper)}>
                  <div>
                    <Typography variant="body1" color="textSecondary">
                      Individual Time From:
                    </Typography>
                  </div>

                  <div className={classnames(classes.travelTimeInputWrapper)}>
                    <div>
                      <TextField
                        id="travelTimeFromHours"
                        name="travelTimeFromHours"
                        className={classnames(classes.textField, classes.travelInput)}
                        value={values.travelTimeFromHours}
                        error={errors && errors.includes('travelTimeFromHours')}
                        onChange={this.handleChange('travelTimeFromHours')}
                        variant="outlined"
                        inputProps={{
                          'aria-label': 'Travel time hours',
                          maxLength: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <label htmlFor="travelTimeFromHours" className={classes.adornment}>
                                h
                              </label>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </div>
                    <div>
                      <TextField
                        id="travelTimeFromMinutes"
                        name="travelTimeFromMinutes"
                        className={classnames(classes.textField, classes.travelInput)}
                        value={values.travelTimeFromMinutes}
                        error={errors && errors.includes('travelTimeFromMinutes')}
                        onChange={this.handleChange('travelTimeFromMinutes')}
                        variant="outlined"
                        inputProps={{
                          'aria-label': 'Travel time minutes',
                          maxLength: 2,
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <label htmlFor="travelTimeFromMinutes" className={classes.adornment}>
                                min
                              </label>
                            </InputAdornment>
                          ),
                        }}
                        fullWidth
                      />
                    </div>
                  </div>
                </div>
              </div>
              <IconButton
                className={classnames(
                  classes.deleteButton,
                  isWorkersType && classes.marginBottom,
                  (!canEdit || (isAnyCropped && values.isShowHours)) && classes.hidden
                )}
                onClick={deleteTravelTime}
                aria-label="Delete"
                disableTouchRipple
              >
                <CloseIcon />
              </IconButton>
            </>
          </div>
        )}
      </div>
    );
  }
}

HoursBlock.propTypes = {
  classes: propTypes.object.isRequired,
  itemHours: propTypes.object.isRequired,
  sheet: propTypes.object.isRequired,
  deleteTime: propTypes.func.isRequired,
  updateResourceHours: propTypes.func.isRequired,
  isWorkersType: propTypes.bool,
};

export default connect((state) => ({
  dateFormat: state.personalProfile.organization?.settings?.dateFormat,
  timeFormat: state.personalProfile.organization?.settings?.timeFormat,
}))(withStyles(styles)(HoursBlock));
